module.exports = __webpack_public_path__ + "img/Polygonhead.77938ffa.svg";